import Test from '../components/Test';
import mountComponent from '../utils/mountComponent';

document.addEventListener('DOMContentLoaded', () => {
  mountComponent('test-mount-point', Test);
});
